import { WFDVideo } from "./wfd_videos";

export interface FormState {
  info: Info;
  likes?: LikesInfo;
  videoId?: string;
  video?: WFDVideo;
}

export interface Info {
  title: string;
  body: string;
  publishedAt?: string;
  category?: string;
}
export type LenderTutorial = {
  _id: string;
  data: FormState;
  updatedAt: string;
  createdAt: string;
};

export type CreateTutorialtRequest = {
  data: FormState;
};

export const categories = ["Getting Started", "Core Features"];

export interface LikesInfo {
  count: number;
  userIds: string[];
}
